import IconButton from "@pathwright/ui/src/components/button/IconButton"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import DownloadsAdd from "./DownloadsAdd"
import "./styles/DownloadsList.css"

const getIconForFileType = function (type) {
  const map = {
    image: "file-image",
    video: "file-video",
    document: "file-text",
    audio: "file-audio",
    code: "file-code",
    archive: "file-zipped"
  }
  let icon = map[type.toLowerCase()]
  if (!icon) {
    icon = "file-text"
  }
  return icon
}

const DownloadsListItem = function ({ download, onDelete, showControls }) {
  let { name, file_type, file_url } = download
  if (file_url == null) {
    file_url = ""
  }

  return (
    <li className="DownloadsListItem">
      {showControls ? (
        <IconButton
          onClick={() => onDelete(download)}
          className="DownloadsListItem__delete"
          styleType="blank"
          icon="plus-circle"
          rotate={45}
          size={30}
          rounded={true}
        />
      ) : undefined}
      <a href={file_url} target="_blank" download={true}>
        <Pathicon
          className="DownloadsListItem__fileicon"
          icon={getIconForFileType(file_type)}
        />
        <span className="DownloadsListItem__label">{name}</span>
        <Pathicon
          className="DownloadsListItem__dlicon"
          icon="arrow-down-circle"
        />
      </a>
    </li>
  )
}

DownloadsListItem.displayName = "DownloadsListItem"

const DownloadsList = ({
  downloads,
  showControls,
  showAddDownload,
  onAdd,
  onDelete
}) => (
  <ul className="DownloadsList">
    {downloads != null
      ? downloads.map((download, index) => (
          <DownloadsListItem
            key={index}
            download={download}
            onDelete={onDelete}
            showControls={showControls}
          />
        ))
      : undefined}
    {showAddDownload ? <DownloadsAdd onAdd={onAdd} /> : undefined}
  </ul>
)

DownloadsList.displayName = "DownloadsList"

export default DownloadsList
